import type { ITelemetryService } from '@/service/vpc/types/ITelemetryService';

type ThanksConfig = {
  show: boolean;
  /** Translation key suffix under components.modal.digital_services_modal.thanks_content */
  descriptionKey: 'description' | 'description_all_services';
};

const hasService = (services: ITelemetryService[], name: ITelemetryService['serviceName']) =>
  services.some((s) => s.serviceName === name);

/**
 * Determines Thank You modal content based on which services were activated.
 * Add new service combinations here as they arise.
 */
export const getActivationThanksConfig = (services: ITelemetryService[]): ThanksConfig => {
  // All services (ActiveMonitoring + Penta_Position)
  if (hasService(services, 'ActiveMonitoring') && hasService(services, 'Penta_Position')) {
    return { show: true, descriptionKey: 'description_all_services' };
  }

  // Core + CSE combination
  if (hasService(services, 'ActiveMonitoringCore') && hasService(services, 'ActiveMonitoring')) {
    return { show: true, descriptionKey: 'description_all_services' };
  }

  // Single service or other combos — default behavior
  return { show: true, descriptionKey: 'description' };
};

/** Batch response uses `errors: Error[]` (empty array on success), single uses `errors: Error[] | null` */
export const isActivationSuccess = (errors: unknown[] | null | undefined): boolean =>
  errors === null || (Array.isArray(errors) && errors.length === 0);

export const hasActiveRequest = (service: ITelemetryService): boolean =>
  service.status === 'Requested' ||
  service.status === 'Deactivating requested' ||
  (Array.isArray(service.currentBatch) && service.currentBatch.length > 0);
